import {
  SET_CURRENT_SELECTED_VISIT,
  SET_CURRENT_VISITS_DETAILS,
  SET_VISITS_FILTERS,
  SET_VISITS_TOTAL_RECORDS,
  SET_VISITS_GRID_SORT_CRITERIA,
  RESET_VISITS_FILTERS,
  FETCH_VISITS_RECORDS,
  SET_VISITS_LIST_IS_LOADING,
  SET_VISITS_LIST_IS_NOT_LOADING,
  SET_VISITS_RECORDS,
  CLEAN_VISITS_RECORDS,
} from './actionTypes';

export const setCurrentSelectedVisit = visit => ({
  type: SET_CURRENT_SELECTED_VISIT,
  visit,
});

export const setGridSortCriteria = sortCriteria => ({
  type: SET_VISITS_GRID_SORT_CRITERIA,
  sortCriteria,
});

export const setCurrentVisitsDetails = details => ({
  type: SET_CURRENT_VISITS_DETAILS,
  details,
});

export const setTotalRecords = totalRecords => ({
  type: SET_VISITS_TOTAL_RECORDS,
  totalRecords,
});

export const setVisitsFilters = filters => ({
  type: SET_VISITS_FILTERS,
  filters,
});

export const cleanVisitsFilters = () => ({
  type: RESET_VISITS_FILTERS,
});

export const fetchVisitsRecords = () => ({
  type: FETCH_VISITS_RECORDS,
});

export const setVisitsGridIsLoading = () => ({
  type: SET_VISITS_LIST_IS_LOADING,
});

export const setVisitsGridIsNotLoading = () => ({
  type: SET_VISITS_LIST_IS_NOT_LOADING,
});

export const setVisitsReports = visits => ({
  type: SET_VISITS_RECORDS,
  visits,
});

export const cleanVisitsRecords = () => ({
  type: CLEAN_VISITS_RECORDS,
});
